"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// The table column isn't rendered, but is used to capture props.
var TableColumn = function TableColumn(props) {
  return null;
};

TableColumn.propTypes = {
  field: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  width: _propTypes["default"].string,
  sortable: _propTypes["default"].bool,
  sort: _propTypes["default"].oneOf(['asc', 'desc']),
  comparator: _propTypes["default"].func
};
var _default = TableColumn;
exports["default"] = _default;